import {
  Breadcrumbs,
  DropdownButton,
  Inline,
  Notification,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { SalaryChangesList } from '@omnipresentgroup/features';
import { useNavigate } from 'react-router';

import {
  ADD_BULK_SALARY_CHANGES_PATH,
  ADD_SALARY_CHANGE_PATH,
  HOME_PATH,
} from '../../constants';
import { useManagerUser } from '../../hooks';

const PAGE_TITLE = 'Salary changes';

export const SalaryChanges = () => {
  const navigate = useNavigate();
  const companyId = useManagerUser().companyId;

  const PageHeader = () => {
    return (
      <Inline id="page-header" minH={40} align="center" justify="space-between">
        <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
          {PAGE_TITLE}
        </Typography>
        <DropdownButton
          options={[
            {
              name: 'Add',
              onClick: () => navigate(ADD_SALARY_CHANGE_PATH),
            },
            {
              name: 'Add in bulk',
              onClick: () => navigate(ADD_BULK_SALARY_CHANGES_PATH),
            },
          ]}
          withSelectableAction
        />
      </Inline>
    );
  };

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate(HOME_PATH) },
            {
              id: 'salary-changes',
              title: PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <PageHeader />
      </Stack>
      <Notification
        id="salary-changes-cutoff-alert"
        intent="info"
        title={
          "Important: When requesting a salary change, you can verify the employee's cutoff date and when this change will be effective from once you click on the page to fill in the details of the new salary."
        }
      />
      <SalaryChangesList
        companyId={companyId}
        columnVisibility={{
          employeeName: true,
          reason: true,
          oldAnnualGrossAmount: true,
          newAnnualGrossAmount: true,
          effectiveDate: true,
          requestedAt: true,
        }}
        filters={{ employeeId: true }}
      />
    </>
  );
};
